/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.2.0",
  "gitBuildTime": "2026-01-23T15:10:07.417Z",
  "gitBuildVersion": "2.2.0",
  "gitCommitId": "619cea1",
  "gitCommitIdFull": "619cea12f3cd0cc98404b8d269f6574c7d6bb4e3",
  "gitCommitTime": "2026-01-20T15:14:35.000Z",
  "version": "2.2.0-2026-01-20T15:14:35.000Z-(619cea1)"
};
